import React from 'react';
import { motion } from 'framer-motion';
interface WavesProps {
  className?: string;
  count?: number;
  color?: string;
}
export function Waves({
  className = '',
  count = 4,
  color = 'rgba(26,143,212,0.15)'
}: WavesProps) {
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-141">
      <svg className="absolute inset-x-0 bottom-0 w-full" viewBox="0 0 1440 320" preserveAspectRatio="none" style={{
      height: '100%'
    }} data-id="element-142">
        {Array.from({
        length: count
      }).map((_, i) => <motion.path key={i} fill={color} initial={{
        d: 'M0,160 C320,200 720,80 1440,160 L1440,320 L0,320 Z'
      }} animate={{
        d: [`M0,${160 + i * 10} C320,${200 + i * 10} 720,${80 + i * 10} 1440,${160 + i * 10} L1440,320 L0,320 Z`, `M0,${160 + i * 10} C320,${100 + i * 10} 720,${220 + i * 10} 1440,${130 + i * 10} L1440,320 L0,320 Z`, `M0,${160 + i * 10} C320,${200 + i * 10} 720,${80 + i * 10} 1440,${160 + i * 10} L1440,320 L0,320 Z`]
      }} transition={{
        duration: 10 + i * 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} style={{
        opacity: 0.5 + i * 0.1
      }} data-id="element-143" />)}
      </svg>
    </div>;
}